import { MxConfig } from '.';

export const config: MxConfig = {
  hotjarId: 0,
  stripePublishableKey:
    'pk_test_51QR4X2BLn4rBVXgxmzYyGI1rfmw3pquuTdl7dhzbcQNwZBIA66qcuKE7xrE9lwmP9KckmSDQRmYRdEuZOPdNm3nS00GfBKPxGs',
  domain: 'onfinality.me',
  homePage: 'http://www.onfinality.me/',
  apiUrl: 'https://api.onfinality.me/api/v1',
  apiUrlV2: 'https://api.onfinality.me/api/v2',
  lightningRestoreDocument:
    'https://onfinality-support-centre.scrollhelp.site/support/Lightning-Restore.1651703824.html',
  networkEditOnOff: {
    versionList: true,
    bootnodes: true,
    recommend: true,
  },
  auth: {
    domain: 'dev-g5z5mu9t.au.auth0.com',
    clientID: '2mI6mjARP4hTlQNpu8EH2t91DfkX28TL',
    redirectUri: 'https://app.onfinality.me/callback',
  },
  recommendNetworks: ['kusama', 'polkadot'],
  featureFlags: {
    showUserNetworkSpec: true,
    showNetworkAPIReport: true,
  },
  currentTosVer: '2021-10-11',
  currentPpVer: '2021-10-11',
  popularNetworkKey: ['acala-dev', 'bifrost', 'calamari', 'heiko', 'Karura', 'nodle-dev', 'parallel-dev', 'polkadot'],
  popularNetworkKeyForNodes: [
    'acala-dev',
    'bifrost',
    'calamari',
    'heiko',
    'Karura',
    'nodle-dev',
    'parallel-dev',
    'polkadot',
  ],
  gaMeasurementId: 'G-5EBM7QSCH2',
  captchaPublicSiteKey: '6LdttC0kAAAAADhvjUVlEM0dM6IMKYPNK4dlHTi8',
  clusterHash: { aws: ['sy'] },
};
